































































import AccountingSystem from "@/data/AccountingSystem";
import { Component, Vue, Prop } from "vue-property-decorator";

import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class SideNav extends Vue {
    @Prop({ type: Boolean })
    isBalance?: boolean;

    @Prop({ type: Boolean })
    isAnnual?: boolean;

    @Prop({ type: Boolean })
    role?: boolean;

    @Prop({ type: Boolean })
    isAssisAccount?: boolean;

    @Prop({ type: Boolean })
    isBusiness?: boolean;

    @Prop({ type: Function })
    refreshData: any;

    @Prop({type: Boolean})
    isPay?: boolean;
    
    @Prop({type: String})
    top?: string;

    @Prop({type: Number})
    actIndex?: number;

    height: string = ""
    payTop: string = "96px"

    searchList: any = []
    sideNavList: NavList[] = [
        { name: "项目", dataList: "dimItemList" },
        { name: "客户", dataList: "dimCustomerList" },
        { name: "供应商", dataList: "dimProviderList" },
        { name: "部门", dataList: "dimDepartmentList" },
        { name: "员工", dataList: "dimEmployeeList" },
        { name: "存货", dataList: "dimInventoryList" }
    ];
    searchKeyList: string[] = ["收入趋势图", "全国客户数", "全国员工数", "全国L<br/>T<br/>V分析"]

    assistNavList: AssistSide[] = [
        { text: "项目", listName: "dimItemList", statusCode: "0", field: "dim/item" },
        { text: "客户", listName: "dimCustomerList", statusCode: "1", field: "dim/customer" },
        { text: "供应商", listName: "dimProviderList", statusCode: "1", field: "dim/provider" },
        { text: "部门", listName: "dimDepartmentList", statusCode: "0", field: "dim/department" },
        { text: "员工", listName: "dimEmployeeList", statusCode: "0", field: "dim/employee" },
        { text: "存货", listName: "dimInventoryList", statusCode: "2", field: "dim/inventory" }
    ]
    activeIndex: number | null = 0;

    mounted() {
        let name = ""
        if(this.isPay){
            this.assistNavList = [
                { text: "工资表", listName: "工资表", statusCode: "0", field: "工资表" },
                { text: "员工信息", listName: "员工信息", statusCode: "1", field: "员工信息" },
            ]
            this.activeIndex = <number>this.actIndex;
            this.payTop = "66px";
            if(this.top) this.payTop = this.top;
        }
        if (this.role) {
            this.searchList = [];
            Vue.axios.get(`accounts/findmyallaccounters?accounterNo=${this.$store.state.account.no}&page=0&size=200`).then(res => {
                if (res.data.content.length > 1) {
                    this.searchList = [{
                        name: "所有",
                        no: this.$store.state.account.no,
                        scope: "all",
                    }];
                    for (var i = 0; i < res.data.content.length; i++) {
                        if (res.data.content[i].name.indexOf("组") == -1) {
                            name = res.data.content[i].name;
                        } else {
                            name = res.data.content[i].name.substr(res.data.content[i].name.indexOf("组") + 1, 5);
                        }
                        if(this.searchList.length < 201){
                            this.searchList.push({
                            name: name,
                            no: res.data.content[i].no,
                            scope: ""
                          })
                        }
                    }
                }
            });
        }
        if (this.isBalance) {
            this.activeIndex = null;
            if (
                this.$store.state.accountBook.accountingSystem ==
                AccountingSystem.thirteenRule
            ) {
                this.sideNavList = [
                    { name: "资产", number: 1 },
                    { name: "负债", number: 2 },
                    { name: "权益", number: 3 },
                    { name: "成本", number: 4 },
                    { name: "损益", number: 5 }
                ];
            } else if (
                this.$store.state.accountBook.accountingSystem ==
                AccountingSystem.sevenNormal || this.$store.state.accountBook.accountingSystem ==
                AccountingSystem.nineteenRule
            ) {
                this.sideNavList = [
                    { name: "资产", number: 1 },
                    { name: "负债", number: 2 },
                    { name: "共同", number: 6 },
                    { name: "权益", number: 3 },
                    { name: "成本", number: 4 },
                    { name: "损益", number: 5 }
                ];
            }else if (
                this.$store.state.accountBook.accountingSystem ==
                AccountingSystem.rural
            ) {
                this.sideNavList = [
                    { name: "资产", number: 1 },
                    { name: "负债", number: 2 },
                    { name: "权益", number: 3 },
                    { name: "成本", number: 4 },
                    { name: "损益", number: 5 }
                ];
            }
            
             else {
                this.sideNavList = [
                    { name: "资产", number: 1 },
                    { name: "负债", number: 2 },
                    { name: "净资产", number: 7 },
                    { name: "收入", number: 8 },
                    { name: "费用", number: 9 }
                ];
            }
        }
    }

    letterClick(item: NavList, index: number) {
        this.activeIndex = index;
        this.$emit("update:nav", item.name);
        this.$emit("change", item);
    }

    // 辅助核算侧边点击
    assistClick(item: AssistSide, index: number) {
        this.activeIndex = index;
        this.$emit("update:nav", item.text);
        this.$emit("change", item);
    }
    // 经营分析侧边点击
    businessClick(item: string, index: number) {
        this.activeIndex = index;
        this.$emit("update:nav", item);
        this.$emit("change", item);
    }
    // 进度监测侧边点击
    dashClick(item: any, index: any) {
        this.activeIndex = index;
        this.$emit("update:nav", item);
        this.$emit("change", item);
        this.showRoles = false;
    }

    showRoles = false;
}
